import React, { useState, useEffect } from "react";
import es_ES from "rsuite/locales/es_ES";
import {
  Calendar,
  List,
  HStack,
  Button,
  Text,
  Modal,
  Input,
  toaster,
  Message,
  SelectPicker,
  DatePicker,
  NumberInput,
  CustomProvider,
} from "rsuite";
import {
  getCitas,
  getHorarios,
  getPaciente,
  saveCancelCita,
  saveUpdateCita,
} from "./Services/ConsultasServices";
import { FaTrash } from "react-icons/fa";
import { ClockIcon } from "lucide-react";
import moment from "moment/moment";
import { Image } from "react-bootstrap";

export const Citas = () => {
  const [idNegocio] = useState(JSON.parse(localStorage.getItem("auth")).id);
  const [negocio] = useState(
    JSON.parse(localStorage.getItem("auth")).consultorio
  );
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // Initial check
  const idUser = JSON.parse(localStorage.getItem("auth")).idUser;
  const [lista, setLista] = useState([]);
  const [fechaCita, setFechaCita] = useState("");
  const [motivoCancel, setMotivoCancel] = useState("");
  const [dataCancel, setDataCancel] = useState("");
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);
  const [btnCancel, setBtnCancel] = useState(false);
  const [fecha, setFecha] = useState("");
  const [idPaciente, setIdPaciente] = useState(0);
  const [paciente, setPaciente] = useState("");
  const [telefono, setTelefono] = useState("");
  const [openHor, setOpenHor] = useState(false);
  const [dataEdit, setDataEdit] = useState("");
  const [disableBtn, setDisableBtn] = useState(true);
  const handleCloseHorario = () => setOpenHor(false);
  const [dataHorarios, setDataHorarios] = useState([]);
  const [disableHors, setDisableHors] = useState(true);
  const [fechaHorario, setFechaHorario] = useState("");
  const [horario, setHorario] = useState("");
  const [nuevaCita, setNuevaCita] = useState(false);
  const [horNvaCita, setHorNvaCita] = useState("");
  const [message, setMessage] = useState("");
  const [disabledBtmMsj, setDisabledBtnMsj] = useState(true);
  const [espacio, setEspacio] = useState(0);
  const [currentTime, setCurrentTime] = useState(new Date());

  const toast = (msg, type = "info") => {
    toaster.push(
      <Message showIcon type={type} closable>
        <strong>{type}!</strong>
        &nbsp; {msg}
      </Message>,
      { duration: 5000, placement: "topCenter" }
    );
  };

  const fetchHorarios = async (fecha) => {
    await getHorarios(idNegocio, fecha).then((nxt) => {
      setFechaHorario(fecha);
      setDataHorarios(nxt);
    });
  };

  const fetchPaciente = async (valueTel) => {
    setTelefono(valueTel);
    const response = await getPaciente(idNegocio, valueTel);
    if (response.status === 204) {
      setPaciente("");
    } else {
      setPaciente(response.nombre);
    }
  };

  const handleChangeTelefono = async (value) => {
    setTelefono(value);
    if (value) {
      if (value.length === 10) {
        fetchPaciente(value);
      } else {
        setPaciente("");
      }
    } else {
      setPaciente("");
    }
  };

  const fetchCitas = async (date) => {
    await getCitas(idNegocio, date, "Todas").then((nxt) => {
      setLista(nxt.lstCitas);
      const citas = nxt.lstCitas;
      return citas.length;
    });
  };


  const cancelarCita = async () => {
    var url = `Consultas/cancelarCita`;
    const datos = {
      id: idNegocio,
      espacio: espacio,
      fecha: fechaCita,
      idUser: idUser,
      motivo: motivoCancel,
    };

    if (!motivoCancel) {
      toast("Debes escribir un motivo antes de guardar", "warning");
      return;
    }

    const res = await saveCancelCita(datos);
    if (res === 0) {
      toast("No se ha cancelado la cita, intente nuevamente.", "warning");
      return;
    } else {
      toast("La cita se ha cancelado de forma correcta.", "success");
      setOpen(false);
      const utcDate = moment(fecha).format("YYYY-MM-DD");
      fetchCitas(utcDate);
    }
  };

  const save = async () => {
    var url = `Consultas/updateCita`;
    const dataCita = {
      id: idNegocio,
      idPaciente: idPaciente,
      espacio: espacio,
      fechaAnterior: nuevaCita ? fecha : fechaCita,
      fecha: nuevaCita ? fecha : fechaHorario.substring(0, 10),
      hora: horario,
      nombre: paciente,
      telefono: telefono,
      correo: "",
      domicilio: "",
      edoMun: "",
      descripCita: "",
      nuevaCita: nuevaCita,
    };

    const res = await saveUpdateCita(dataCita);
    if (res === -1) {
      toast("El horario ya no se encuentra disponible.", "warning");
      return;
    }
    toast("Se actualizo la cita de forma correcta", "success");
    fetchCitas(fecha);
    setDisableBtn(true);
    setDisabledBtnMsj(false);
  };

  const sendMessage = () => {
    var anchor = document.createElement("a");
    anchor.href = `https://api.whatsapp.com/send?phone=${telefono}&text=${message}`;
    anchor.target = "_blank";
    anchor.click();
    setOpenHor(false);
  };

  const handleSelect = (date) => {
    const _date = moment(date).format("DD/MMM/YYYY");
    const utcDate = moment(date).format("YYYY-MM-DD");
    setFecha(_date);
    fetchCitas(utcDate);
  };

  const handleEditModal = (props) => {
    setIdPaciente(props.idPac);
    setDisabledBtnMsj(true);
    setMessage("");
    setFechaCita(`${props.fecha} ${props.hora}`);
    setDataEdit(
      `${props.nombre} / (${props.espacio}) ${props.fecha} ${props.hora}`
    );
    setEspacio(props.espacio);
    setTelefono(props.telefono);
    setPaciente(props.nombre);
    setNuevaCita(false);
    setOpenHor(true);
  };

  const handleChangeFec = (e) => {
    if (e != null) {
      var fecha = new Date(e).toISOString();
      setDisableHors(false);

      fetchHorarios(fecha);
    } else {
      setDataHorarios([]);
    }
  };

  const handleDisabledDate = (date) => {
    return date.getTime() < moment().startOf("day").valueOf();
  };

  const handleHorario = (e) => {
    if (e === null) {
      setHorario("");
      setDisableBtn(true);
      setMessage("");
    } else {
      setHorario(e);
      setDisableBtn(false);
      const _hor = e.substring(0, 5);
      const _fec = moment(fechaHorario).format("DD/MM/YYYY");
      setMessage(
        `Buen día, le escribimos de ${negocio.NomConsultorio}. Confirmando su cambio de Fecha y hora de la cita para el: ${_fec} en el horario de las: ${_hor}`
      );
    }
  };

  const handleNewCita = (props) => {
    var fec = moment(fecha).format("DD/MM/YYYY");
    setDataEdit(`${fec} a las ${props.hora}`);
    setHorario(props.hora);
    setHorNvaCita(props.hora);
    setTelefono("");
    setPaciente("");
    setNuevaCita(true);
    setOpenHor(true);
  };

  const handleCancel = (props) => {
    if (props.estatus === "Cancelada") {
      setBtnCancel(true);
    } else {
      setBtnCancel(false);
    }

    setFechaCita(`${props.fecha} ${props.hora}`);
    setDataCancel(
      `${props.nombre} / (${props.espacio}) ${props.fecha} ${props.hora}`
    );
    setEspacio(props.espacio);
    setOpen(true);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Update on resize
    };
    fetchPaciente();
    window.addEventListener("resize", handleResize);
    // Set up an interval to update the time every second

    const intervalId = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => {
      window.removeEventListener("resize", handleResize); // Cleanup
    };

    // Clean up the interval when the component unmounts
    return () => clearInterval(intervalId);
  }, []); // Empty dependency array ensures this effect runs only once on mount

  return (
    <div
      style={{
        marginLeft: "5%",
        marginRight: "5%",
        backgroundColor: "white",
        padding: "20px",
        borderRadius: "15px",
      }}
    >
      <HStack
        spacing={10}
        style={{ height: "auto" }}
        alignItems="flex-start"
        wrap
      >
        <CustomProvider locale={es_ES}>
          <Calendar
            compact
            onSelect={handleSelect}
            style={{ width: 320 }}
            bordered
          />
        </CustomProvider>
        <Modal
          open={open}
          onClose={handleClose}
          backdrop="static"
          overflow="false"
        >
          <Modal.Header>
            <Modal.Title>Cita: {dataCancel}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col">
                <b>Motivo</b>
                <Input
                  as="textarea"
                  rows={4}
                  placeholder="Escriba el motivo de la cancelación de la cita."
                  onChange={(e) => setMotivoCancel(e)}
                  disabled={btnCancel}
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={cancelarCita}
              disabled={btnCancel}
              appearance="primary"
            >
              Guardar
            </Button>
            <Button onClick={handleClose} appearance="subtle">
              Cerrar
            </Button>
          </Modal.Footer>
        </Modal>
        {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> MODAL DE EDICION PARA HORARIO <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */}
        <Modal
          open={openHor}
          onClose={handleCloseHorario}
          backdrop="static"
          overflow="false"
        >
          <Modal.Header>
            <Modal.Title>Cita: {dataEdit}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row mb-1">
              <div className="col-lg-4 col-md-4 col-sm-4">
                <b>Teléfono</b>
                <NumberInput
                  controls={false}
                  readOnly={!nuevaCita}
                  onChange={(e) => handleChangeTelefono(e)}
                  value={telefono}
                  maxLength={10}
                  min={0}
                />
              </div>
              <div className="col-lg-8 col-md-8 col-sm-8">
                <b>Nombre</b>
                <Input
                  readOnly={!nuevaCita}
                  value={paciente}
                  onChange={(e) => setPaciente(e)}
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-lg-6 col-md-6 col-sm-6">
                <b>Fecha</b>
                {nuevaCita ? (
                  <Input readOnly value={moment(fecha).format("DD/MM/YYYY")} />
                ) : (
                  <CustomProvider locale={es_ES}>
                    <DatePicker
                      block
                      shouldDisableDate={handleDisabledDate}
                      onChange={(e) => handleChangeFec(e)}
                    />
                  </CustomProvider>
                )}
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6">
                <b>Horario</b>
                {nuevaCita ? (
                  <Input
                    readOnly
                    value={horNvaCita}
                    defaultValue={horNvaCita}
                  />
                ) : (
                  <SelectPicker
                    style={{ width: "auto" }}
                    block
                    searchable={false}
                    data={dataHorarios}
                    disabled={disableHors}
                    onChange={(e) => handleHorario(e)}
                    placeholder="Selecciona un horario"
                  />
                )}
              </div>
            </div>
            <div className="row">
              {!nuevaCita ? (
                <div className="col">
                  <b>Mensaje</b>
                  <Input
                    as="textarea"
                    rows={3}
                    value={message}
                    onChange={(e) => setMessage(e)}
                  />
                </div>
              ) : (
                ""
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              appearance="primary"
              onClick={save}
              disabled={nuevaCita ? false : disableBtn}
            >
              Guardar
            </Button>
            <Button
              appearance="ghost"
              onClick={() => sendMessage()}
              size="sm"
              disabled={disabledBtmMsj}
            >
              <Image
                src="/Images/whatsapp.png"
                style={{ height: "30px" }}
              ></Image>
              &nbsp; Enviar mensaje
            </Button>
            <Button onClick={handleCloseHorario} appearance="default">
              Cerrar
            </Button>
          </Modal.Footer>
        </Modal>
        <div className="row">
          <Text color="blue" weight="bold">
            Citas de la Fecha: <b>{fecha}</b>
          </Text>
          <div className="col">
            <List
              style={{ flex: 1, fontSize: isMobile ? "12px" : "16px" }}
              bordered
            >
              {lista.map((item, index) => (
                <List.Item key={item.hora} index={item.dia}>
                  <div>{item.hora} &nbsp; </div>
                  <div key={`div-disp-${index}`}>
                    {item.espacio === 2 && item.estatus === "Disponible" ? (
                      <Button
                        appearance="ghost"
                        color="green"
                        size="sm"
                        onClick={() =>
                          handleNewCita({
                            idPac: item.idPac,
                            nombre: item.nombre,
                            fecha: item.fecha,
                            hora: item.hora,
                            telefono: item.telefono,
                          })
                        }
                      >
                        {`${item.estatus} (${item.espacio})`}
                      </Button>
                    ) : (
                      <>
                        {item.hora < currentTime.toLocaleTimeString() &&
                        item.fecha === fecha ? (
                          <b style={{ color: "red" }}>No Disponible</b>
                        ) : (
                          <b
                            style={{
                              color:
                                item.estatus === "No Disponible" &&
                                item.espacio === 0
                                  ? "red"
                                  : "black",
                            }}
                          >
                            {item.agendadas.map((itm, ix) => (
                              <>
                                <div id={`${ix}-${index}`}>
                                  {isMobile
                                    ? itm.nombre.length > 20
                                      ? itm.nombre.substring(0, 15) + "..."
                                      : itm.nombre + " (" + itm.espacio + ")"
                                    : itm.nombre + " (" + itm.espacio + ")"}
                                  <Button
                                    appearance="subtle"
                                    title="Cancelar cita"
                                    onClick={() =>
                                      handleCancel({
                                        nombre: itm.nombre,
                                        fecha: itm.fecha,
                                        espacio: itm.espacio,
                                        hora: itm.hora,
                                        telefono: itm.telefono,
                                        estatus: itm.estatus,
                                      })
                                    }
                                  >
                                    {item.estatus === "Ocupado" ? (
                                      <FaTrash
                                        style={{ color: "red" }}
                                      ></FaTrash>
                                    ) : (
                                      ""
                                    )}
                                  </Button>
                                  <Button
                                    onClick={() =>
                                      handleEditModal({
                                        idPac: item.idPac,
                                        espacio: itm.espacio,
                                        nombre: itm.nombre,
                                        fecha: itm.fecha,
                                        hora: itm.hora,
                                        telefono: itm.telefono,
                                      })
                                    }
                                    appearance="subtle"
                                    title="Editar horario"
                                  >
                                    {item.estatus === "Ocupado" ? (
                                      <ClockIcon
                                        size="15px"
                                        style={{ color: "blue" }}
                                      ></ClockIcon>
                                    ) : (
                                      ""
                                    )}
                                  </Button>
                                </div>
                              </>
                            ))}
                          </b>
                        )}
                      </>
                    )}
                  </div>
                  {item.espacio === 1 ? (
                    item.hora >= currentTime.toLocaleTimeString() ? (
                      <Button
                        appearance="ghost"
                        color="green"
                        size="sm"
                        onClick={() =>
                          handleNewCita({
                            idPac: item.idPac,
                            nombre: item.nombre,
                            fecha: item.fecha,
                            hora: item.hora,
                            telefono: item.telefono,
                          })
                        }
                      >
                        Disponible ({item.espacio})
                      </Button>
                    ) : (
                      <Button
                        appearance="ghost"
                        color="green"
                        size="sm"
                        onClick={() =>
                          handleNewCita({
                            idPac: item.idPac,
                            nombre: item.nombre,
                            fecha: item.fecha,
                            hora: item.hora,
                            telefono: item.telefono,
                          })
                        }
                      >
                        Disponible ({item.espacio})
                      </Button>
                    )
                  ) : (
                    ""
                  )}
                </List.Item>
              ))}
            </List>
          </div>
        </div>
        <br></br>
      </HStack>
    </div>
  );
};
